module.exports = __webpack_public_path__ + "img/img1.8fe71392.jpg";